import React, { useState, useEffect } from 'react';
import {
  FormGroup,
  ModalBody,
  Col,
  Button,
  Label,
  Table
} from 'reactstrap'
import ReactSelect from "../../../components/Form/Select/Select"
import rotas from 'services/rotas';
import rest from 'lib/rest';
import Loading from 'lib/loading'
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'

const formSwal = withReactContent(Swal)

const FormImportModeloDesconto = ({ closeModal, setDescontos }) => {

  const initialForm = {
    descricao:  "",
    comentario: "",
    descontos:  []
  }

  const [loading, setLoading]                         = useState(true)
  const [loadingDesc, setLoadingDesc]                 = useState(true)
  const [listaModeloConv, setlistaModeloConv]         = useState([])
  const [listaModeloConvDesc, setlistaModeloConvDesc] = useState(initialForm)
  const [divDesconto, setDivDesconto]                 = useState(true)

  const listaModeloDesconto = () => {
    let lista = [];

    const retorno = rest.get(rotas.convenios+'/modeloDesconto/')
    retorno.then(ret => {
      if (ret != '' && ret.success && ret.success == 'S' && ret.lista!=''){
        ret.lista.map(item => {
          lista.push({ id: item.cab_mod_desconto_id, title: item.descricao, comentario: item.comentario })
        })
        setlistaModeloConv(lista)
      }else{
        setlistaModeloConvDesc(initialForm)
      }
      setLoading(false)
    })
  }

  const listaDescontos = (id) => {
    try{

      if (typeof id != 'undefined' && id !== '') {
        const retorno = rest.get(rotas.convenios+'/modeloDesconto/importar.php?modDescontoId='+id)
        retorno.then(ret => {
          if (ret.success && ret.success == 'S' && ret.lista != '') {
            setlistaModeloConvDesc(ret.lista)
          }
          setLoadingDesc(false)
        })
      }

    }catch(err){
      return (false)
    }
  }

  const onChangeSelectModelo = (e) => {
    setLoadingDesc(true)
    listaDescontos(e.id)
    setDivDesconto(false)
  }

  const DeleteModeloDesc = () => {

    if (listaModeloConvDesc.cab_mod_desconto_id && listaModeloConvDesc.cab_mod_desconto_id !== '') {
      
      let id = listaModeloConvDesc.cab_mod_desconto_id

      formSwal.queue([{
        title:                'Deseja excluir o modelo de desconto ?',
        confirmButtonText:    'Excluir',
        showCancelButton:     true,
        text:                 'Modelo: "'+listaModeloConvDesc.descricao+'", será excluido!',
        showLoaderOnConfirm:  true,
        cancelButtonColor:    '#d33',
        preConfirm: () => {
          const retorno = rest.get(rotas.convenios+'/modeloDesconto/deletar.php?modDescontoId='+id)
          retorno.then(ret => {
            if (ret.success && ret.success == 'S') {
              setDivDesconto(true)
              setlistaModeloConvDesc(initialForm)
              listaModeloDesconto()
              formSwal.fire('Modelo de desconto excluído!','Modelo foi excluído do banco','success')

            }else{
              formSwal.fire('Erro !',ret.msg,'error')
            }
          })
        }
      }])

    }
  }

  //IMPORTAR MODELO CONVÊNIO
  const ImportarModeloDesc = (evt) => {
    evt.preventDefault()

    if (listaModeloConvDesc.descontos.length > 0) {
      formSwal.queue([{
        title:                'Deseja importar os descontos ?',
        confirmButtonText:    'Importar',
        showCancelButton:     true,
        text:                 'Lembre-se que depois da importação, terá que salvar as alterações no convênio.',
        showLoaderOnConfirm:  true,
        cancelButtonColor:    '#d33',
        preConfirm: () => {
  
          let descontosNovos = listaModeloConvDesc.descontos

          descontosNovos.map((novo) =>
            setDescontos((prevState) =>
              prevState.map((item) =>
                item.categoria_id === novo.categoria_id 
                  ? {...item, desconto: novo.desconto, mark_up: novo.mark_up, permitir_venda: novo.permitir_venda == 'Sim' ? true : false }
                  : item
              )
            )
          )
          closeModal()
          formSwal.fire('Dados Importados !','Lembre-se de salvar as alterações no convênio','success')
        }
      }])
    }else{
      formSwal.fire('Sem Modelo Selecionado','Por favor selecione um Modelo de descontos','warning')
    }
  }

  useEffect(()=>{
    listaModeloDesconto()
  },[])

  if (loading) {
    return (
      <ModalBody className="loadingBody">
        <Loading tipo='componente' />
      </ModalBody>
    )
  } else {
    return (
      <FormGroup className="formCadastro">

        <ModalBody className="pb-0" >
          <Col md='12'>
            <FormGroup>
              <Label for="bairro">Nome Modelo de Desconto</Label>
              <ReactSelect
                id          = "nome"
                name        = "nome"
                placeholder = "Selecione o modelo"
                options     = {listaModeloConv}
                onChange    = {onChangeSelectModelo}
              />
            </FormGroup>
          </Col>

          <div hidden={divDesconto}>
            { loadingDesc ? 
                <Loading tipo='componente' />
              : 
              <>
                <Col md='12'>
                  <Label><h6 className="title">Observação</h6></Label> 
                  <FormGroup>
                    <Label for="bairro">{listaModeloConvDesc.comentario}</Label>
                  </FormGroup>
                </Col>

                <Col md='12'>
                  <Label><h6 className="title">Descontos</h6></Label> 
                  <Table>
                    <thead>
                      <tr>
                        <th>CATEGORIA</th>
                        <th>PERMITIR VENDA</th>
                        <th>DESCONTO</th>
                        <th>MARK-UP</th>
                      </tr>
                    </thead>
                    <tbody>
                      {
                        listaModeloConvDesc.descontos.length > 0 ?
                          listaModeloConvDesc.descontos.map((lista) => (
                            <tr key={lista.item_mod_desconto_id}>
                              <td>{lista.categoria}</td>
                              <td>{lista.permitir_venda}</td>
                              <td>{lista.desconto+' %'}</td>
                              <td>{lista.mark_up+' %'}</td>
                            </tr>
                          ))
                        : (<tr></tr>)
                      }
                    </tbody>
                  </Table>
                </Col>
              </>
            }
          </div>

          <Col className="text-center p-3" md='12'>
            <Button type="button" className="mb-0 mt-0" color="success" size="md" onClick={ImportarModeloDesc}>Importar</Button>
            <Button type="button" className="mb-0 mt-0" color="danger" size="md" onClick={DeleteModeloDesc}>Excluir</Button>
            <Button className="mb-0 mt-0" color="default" size="md" onClick={closeModal}>Fechar</Button>
          </Col>
        </ModalBody>
      </FormGroup>
    )
  }

}

export default FormImportModeloDesconto
